/** User-facing English messages for common Supabase / Azure auth errors. */
export function formatAuthErrorMessage(message: string): string {
  if (message.includes('AADSTS50194')) {
    return (
      'Azure app is single-tenant but login used the /common endpoint. ' +
      'In Supabase → Authentication → Providers → Azure, set Azure Tenant URL to ' +
      'https://login.microsoftonline.com/YOUR_TENANT_ID (Entra → Overview).'
    );
  }

  if (
    message.includes('Unable to exchange external code') ||
    message.includes('unable to exchange external code')
  ) {
    return (
      'Microsoft rejected the sign-in code (Unable to exchange external code). ' +
      'Fix in Azure Portal → App registrations → BTH CRM Web → Authentication: ' +
      '(1) Add a Web platform (not SPA) with redirect URI ' +
      'https://YOUR-PROJECT.supabase.co/auth/v1/callback only. ' +
      '(2) Remove the same URI from SPA if listed there. ' +
      '(3) In Supabase → Azure provider, paste a new client secret Value (not Secret ID). ' +
      'See docs/LOGIN-MICROSOFT.md'
    );
  }

  if (message.includes('Error getting user email')) {
    return (
      'Microsoft signed in but did not return an email. ' +
      'In Azure → API permissions, add Microsoft Graph delegated: email, openid, profile, User.Read, ' +
      'then Grant admin consent.'
    );
  }

  if (message.includes('AADSTS7000215') || message.includes('Invalid client secret')) {
    return (
      'Invalid Azure client secret in Supabase. Create a new secret in Entra and paste the ' +
      'Secret Value (not the Secret ID) into Supabase → Authentication → Providers → Azure.'
    );
  }

  return message;
}
